export const AI_SUGGESTED_BADGE = "activation.setup.competitors.step.ai.suggested.badge";
